import type { LandingCopy } from './types'

export const landingPl: LandingCopy = {
  heroTitle: 'Rozumiej angielski podczas czytania.',
  heroSubtitleLines: ['Dotknij dowolnego słowa.', 'Wyjaśnimy je.', 'Zapamiętasz je.'],
  demoHint: 'Konto nie jest wymagane',
  demoReadLabel: 'Czytaj',
  demoUnderstandLabel: 'Zrozum',
  demoTapHint: 'Dotknij podświetlonego słowa, aby zobaczyć znaczenie',
  demoMeans: 'Znaczenie',
  demoInContext: 'W tym zdaniu',
  demoExampleLabel: 'Przykład',
  demoLocalizedNote: 'Zarejestruj się, aby zapisywać słowa i spotykać je ponownie w powtórkach.',
  signUpToSave: 'Zarejestruj się, aby zapisywać słowa',
  savedNudge: 'Zapisano — jutro powtórzysz „{word}”.',
  capabilitiesTitle: 'Silnik twojego postępu',
  capabilitiesSubtitle:
    'Nie tylko czytanie. Słowa, które wybierasz, stają się artykułami, praktyką, testami i powtórkami — jeden cykl, który nieprzerwanie prowadzi do przodu.',
  capabilities: [
    {
      title: 'Czytaj i rozumiej',
      body: 'Dotknij słowa lub frazy — wyjaśnienie w kontekście.',
    },
    {
      title: 'Twój słownik',
      body: 'Zapisuj to, co ważne — osobista lista do rozwoju.',
    },
    {
      title: 'Powtórki',
      body: 'Powtórki rozłożone w czasie, gdy prawie zapomniałeś.',
    },
    {
      title: 'Artykuły z twoich słów',
      body: 'AI pisze teksty na twoim poziomie wokół zapisanych słów.',
    },
    {
      title: 'Praktyka',
      body: 'Historie i lekcje ze słów, które już znasz.',
    },
    {
      title: 'Testy',
      body: 'Sprawdź się i zobacz, co naprawdę utkwiło.',
    },
  ],
  finalTitle: 'Gotowy zamienić słowa w postęp?',
  getStarted: 'Zacznij za darmo',
  signIn: 'Zaloguj się',
  footerFaq: 'FAQ',
  footerPrivacy: 'Polityka prywatności',
  footerTerms: 'Regulamin',
  localeSwitcherLabel: 'Język',
}
